export default "__VITE_ASSET__BPq6cu5C__"